import React, { type ReactNode } from 'react'

import { _InternalThemeProvider, useThemeElevation } from '../ThemeProvider'

type Props = {
  children: (p: { rootClassName: string }) => ReactNode
  /**
   * Specifying an elevation amount of 0 is useful for components that
   * need to return a stable node (e.g. because this element's children need
   * to animate between their elevated and unelevated states). Instead of
   * returning the children without an _InternalElevate wrapper, components
   * can continue to return an _InternalElevate without an amount.
   */
  amount?: 0 | 1
}

export function InternalElevate({ amount = 1, children }: Props) {
  const elevation = useThemeElevation()
  return (
    <_InternalThemeProvider elevation={elevation + amount}>
      {children}
    </_InternalThemeProvider>
  )
}
